import { FormBase } from 'core/components';

export default class LabelingStepForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'upc',
					label: 'FULFILLMENTORDER.LABELINGMODE.UPC',
					rules: 'required',
				},
			],
		};
	}

	options() {
		return {
			validateOnChange: true,
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/labeling-mode/LabelingStepForm.js